import { useQuery } from "@tanstack/react-query";
import { getAllLocationsFromSLM } from "../../../../services/locations.service";
import { INTERVAL } from "../../../../constants/clientTime";

export const useFetchSlmData = () => {
  return useQuery({
    queryKey: ["fetchSlmData"],
    queryFn: async () => await getAllLocationsFromSLM(),
    staleTime: INTERVAL.HOUR * 2,
  });
};
